import { getTokens } from '@dacr/auth'

export const applyAuthorizationToken = (
  source?: string | null | undefined,
  extraParams?: { key: string; value: string | number }[]
): string | undefined => {
  if (!source) {
    return undefined
  }
  const { accessToken } = getTokens()
  if (!accessToken || /[?&]X-Amz-Signature=/i.test(source)) {
    return source
  }

  let url = new URL(source)
  const params = source.split('?')
  if (params && params.length > 1) {
    url = new URL(params[0])
    params.forEach((param) => {
      const attributes = param.split('=')
      url.searchParams.append(attributes[0], attributes[1])
    })
  }
  if (extraParams) {
    extraParams.forEach((param) => {
      url.searchParams.append(param.key, String(param.value))
    })
  }
  url.searchParams.append('authorization', `Bearer ${accessToken}`)
  return url.href
}

export const downloadURLContent = (filename: string, url: string) => {
  const anchorTag = document.createElement('a')
  anchorTag.href = url
  anchorTag.download = filename
  anchorTag.click()
}
